// extracted by mini-css-extract-plugin
module.exports = {"inputText":"textInput_inputText__1-1db","fullWidth":"textInput_fullWidth__3OH4K"};